import warningImageUrl from "@/assets/warning.svg"
import { Button } from "@/components/chadcn/Button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/chadcn/Dialog"
import { ROUTES } from "@/routes"
import { useEffect } from "react"
import { useNavigate } from "react-router"

type WarningModalProps = {
  open: boolean
  reading: number | null
  message: string | null
  onClose: () => void
}

export const WarningModal = ({ open, reading, message, onClose }: WarningModalProps) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="sr-only">Warning</DialogTitle>
      </DialogHeader>
      <div className="flex justify-center">
        <img alt="warning" src={warningImageUrl} width={120} />
      </div>
      <p className="mt-2 text-center text-lg font-semibold">
        Your reading was <span>{reading}</span>
      </p>
      {message && <p className="mt-2 break-words text-base font-medium">{message}</p>}
      <Button type="button" className="mt-4 w-full" onClick={onClose}>
        OK
      </Button>
    </DialogContent>
  </Dialog>
)

type ConfettiModalProps = {
  open: boolean
  onDismiss: () => void
}

export const ConfettiModal = ({ open, onDismiss }: ConfettiModalProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!open) return
    const timeoutId = setTimeout(() => onDismiss(), 4000)
    return () => clearTimeout(timeoutId)
  }, [open, onDismiss])

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onDismiss()}>
      <DialogContent className="max-w-xs text-center">
        <DialogHeader>
          <DialogTitle className="text-center font-kaushan text-[32px] font-semibold">
            Woohoo!
          </DialogTitle>
        </DialogHeader>
        <p className="text-[20px] leading-7">Your log has been submitted</p>
        <Button
          type="button"
          variant="ghost"
          className="mt-2 underline"
          onClick={() => navigate(ROUTES.DASHBOARD)}
        >
          Go to dashboard
        </Button>
      </DialogContent>
    </Dialog>
  )
}
